export const LocalStorage = {
	user_info: 'userInfo',
	user_token: 'userToken',
	user_main_info: 'userMainInfo',
	location: 'locationStore',
	coverage: 'customerCoverage',
};
